"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegulatedSpacesLink = exports.StyledRegulatedSpacesBanner = exports.NoResultsContent = exports.NoResultsContainer = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const banner_1 = __importDefault(require("@kyruus/banner"));
const styled_1 = __importDefault(require("@emotion/styled"));
exports.NoResultsContainer = (0, styled_1.default)('div') `
  display: table;
  margin: 0 auto;
`;
exports.NoResultsContent = (0, styled_1.default)('div') `
  display: flex;
  align-items: center;
  flex-direction: column;

  > strong {
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  }

  > section {
    display: flex;
    align-items: center;

    &:last-child {
      margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
      white-space: nowrap;
      width: 100%;
      justify-content: flex-end;
    }
  }

  button {
    margin-left: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    &:first-of-type {
      margin-left: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    }
  }
`;
exports.StyledRegulatedSpacesBanner = (0, styled_1.default)(banner_1.default) `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_small')};
`;
exports.RegulatedSpacesLink = (0, styled_1.default)('a') `
  color: ${(0, ui_theme_1.fromTheme)('color_link')};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
//# sourceMappingURL=styles.js.map